import { render, staticRenderFns } from "./OnboardingModal.container.vue?vue&type=template&id=5c007cd2&"
import script from "./OnboardingModal.container.vue?vue&type=script&lang=ts&"
export * from "./OnboardingModal.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports